import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { patrolEventsUrl } from '../api/client';

export function usePatrolStream() {
  const queryClient = useQueryClient();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const source = new EventSource(patrolEventsUrl());
    source.addEventListener('ready', () => setConnected(true));
    source.addEventListener('patrol', () => {
      void queryClient.invalidateQueries({ queryKey: ['patrol-dashboard'] });
    });
    source.onerror = () => setConnected(false);
    return () => source.close();
  }, [queryClient]);

  return connected;
}
